import { container } from '~/base'

type Props = React.ComponentPropsWithoutRef<'div'> & {}

export function Container({ children }: Props) {
  return <div className={container()}>{children}</div>
}
